<div class="circle"></div>
<mg-ui-checkmark [class.isChecked]="isChecked"></mg-ui-checkmark>
